import React from "react";

export default function PrivacyAndPolicy() {
  return (
    <div className="bg-gray-50 py-12 px-4 md:px-10 lg:px-20">
      <div className="max-w-5xl mx-auto bg-white p-8 rounded-2xl shadow-lg border border-gray-200">

        <h1 className="text-3xl font-bold mb-4 text-gray-900">
          Privacy Policy
        </h1>

        <p className="text-gray-500 mb-6">
          Last updated: March 17, 2026
        </p>

        <p className="mb-6 text-gray-700 leading-relaxed">
          This Privacy Policy describes Our policies and procedures on the
          collection, use and disclosure of Your information when You use the
          Service and tells You about Your privacy rights and how the law
          protects You.
        </p>

        {/* Interpretation */}
        <h2 className="text-2xl font-semibold mt-8 mb-3 text-gray-900">
          Interpretation and Definitions
        </h2>

        <h3 className="text-xl font-semibold mt-4 mb-2 text-gray-800">
          Interpretation
        </h3>
        <p className="text-gray-700 mb-4">
          The words whose initial letters are capitalized have meanings defined
          under the following conditions.
        </p>

        <h3 className="text-xl font-semibold mt-4 mb-2 text-gray-800">
          Definitions
        </h3>

        <ul className="list-disc pl-6 space-y-2 text-gray-700">
          <li><strong>Account:</strong> A unique account created for You.</li>
          <li><strong>Affiliate:</strong> Entity under common control.</li>
          <li><strong>Company:</strong> Abhishek M Financial Services Pvt Ltd.</li>
          <li><strong>Cookies:</strong> Small files stored on your device.</li>
          <li><strong>Country:</strong> Telangana, India.</li>
          <li><strong>Device:</strong> Any device accessing the service.</li>
          <li><strong>Personal Data:</strong> Information identifying an individual.</li>
          <li><strong>Service:</strong> The Website.</li>
          <li><strong>Service Provider:</strong> Third-party service providers.</li>
          <li><strong>Usage Data:</strong> Automatically collected data.</li>
          <li><strong>Website:</strong> Abhishek M Financial Services.</li>
          <li><strong>You:</strong> User accessing the service.</li>
        </ul>

        {/* Data Collection */}
        <h2 className="text-2xl font-semibold mt-10 mb-3 text-gray-900">
          Collecting and Using Your Personal Data
        </h2>

        <h3 className="text-xl font-semibold mt-4 mb-2 text-gray-800">
          Types of Data Collected
        </h3>

        <p className="text-gray-700 mb-2 font-medium">Personal Data may include:</p>
        <ul className="list-disc pl-6 space-y-1 text-gray-700">
          <li>Email address</li>
          <li>First name and last name</li>
          <li>Phone number</li>
        </ul>

        <h3 className="text-xl font-semibold mt-6 mb-2 text-gray-800">
          Usage Data
        </h3>
        <p className="text-gray-700 mb-4">
          Usage Data is collected automatically including IP address, browser
          type, pages visited, and time spent.
        </p>

        {/* Cookies */}
        <h3 className="text-xl font-semibold mt-6 mb-2 text-gray-800">
          Cookies & Tracking Technologies
        </h3>
        <p className="text-gray-700 mb-4">
          We use cookies to improve user experience and analyze website usage.
        </p>

        {/* Use of Data */}
        <h3 className="text-xl font-semibold mt-6 mb-2 text-gray-800">
          Use of Your Personal Data
        </h3>

        <ul className="list-disc pl-6 space-y-2 text-gray-700">
          <li>To provide and maintain our service</li>
          <li>To manage your account</li>
          <li>To contact you</li>
          <li>To improve our services</li>
        </ul>

        {/* Retention */}
        <h3 className="text-xl font-semibold mt-6 mb-2 text-gray-800">
          Retention of Data
        </h3>
        <p className="text-gray-700 mb-4">
          We retain your data only as long as necessary for legal and business
          purposes.
        </p>

        {/* Security */}
        <h3 className="text-xl font-semibold mt-6 mb-2 text-gray-800">
          Security
        </h3>
        <p className="text-gray-700 mb-4">
          We take reasonable measures to protect your data but cannot guarantee
          complete security.
        </p>

        {/* Children */}
        <h2 className="text-2xl font-semibold mt-10 mb-3 text-gray-900">
          Children's Privacy
        </h2>
        <p className="text-gray-700 mb-4">
          We do not knowingly collect data from children under 16.
        </p>

        {/* Changes */}
        <h2 className="text-2xl font-semibold mt-10 mb-3 text-gray-900">
          Changes to this Privacy Policy
        </h2>
        <p className="text-gray-700 mb-4">
          We may update this policy from time to time.
        </p>

        {/* Contact */}
        <h2 className="text-2xl font-semibold mt-10 mb-3 text-gray-900">
          Contact Us
        </h2>

        <ul className="space-y-2 text-gray-700">
          <li>Email: sunoji@abhifs.com</li>
          <li>
            Website:{" "}
            <a
              href="/contact"
              className="text-green-600 hover:underline"
            >
              Contact Page
            </a>
          </li>
          <li>Phone: +91 93463 99632</li>
        </ul>

      </div>
    </div>
  );
}